'use client';

import { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

const GalleryNavContext = createContext(null);

export function GalleryNavProvider({ galleryNav, children }) {
  const value = useMemo(() => galleryNav, [galleryNav]);
  return <GalleryNavContext.Provider value={value}>{children}</GalleryNavContext.Provider>;
}

GalleryNavProvider.propTypes = {
  galleryNav: PropTypes.shape({
    megaMenu: PropTypes.shape({
      items: PropTypes.array.isRequired,
      columns: PropTypes.array,
    }).isRequired,
    drawerLinks: PropTypes.array.isRequired,
    galleryHrefs: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export function useGalleryNav() {
  return useContext(GalleryNavContext);
}
